import React, { useState } from 'react';
import ModalWrapper from './ModalWrapper';

interface CustomDialogProps {
  type: 'alert' | 'confirm' | 'prompt';
  message: string;
  onConfirm: (value?: string) => void;
  onCancel?: () => void;
  onClose: () => void;
  confirmButton?: string;
  cancelButton?: string;
  title?: string; // <-- NEU
  danger?: boolean;
}

const CustomDialog: React.FC<CustomDialogProps> = ({
  type, message, onConfirm, onCancel, onClose, confirmButton, cancelButton,  title, danger
}) => {
  const [inputValue, setInputValue] = useState('');

  return (
    <ModalWrapper onClose={onClose}>
      
      <header className="tw-text-center tw-mb-6 tw-text-gray-600 tw-z-20 tw-bg-white">
        {title && (
      <h2 className="tw-text-lg tw-font-semibold tw-mb-2">{title}</h2>
    )}
        <p className="tw-text-sm tw-text-gray-500">{message}</p>
      </header>

      {type === 'prompt' && (
        <input
          className="tw-mb-4 tw-border tw-rounded tw-px-2 tw-py-1"
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
      )}

      <div className="tw-flex tw-justify-end tw-gap-2">
        {(type === 'confirm' || type === 'prompt') && (
          <button onClick={onCancel} className="_button_19rto_40 _secondary_19rto_163 _outlined_19rto_69">{cancelButton || 'Abbrechen'}</button>
        )}
        <button
          onClick={() => {
            if (type === 'prompt') onConfirm(inputValue);
            else onConfirm();
          }}
          className={`_button_19rto_40 ${danger ? 'bg-red-600 hover:bg-red-500 text-white hover:text-white' : '_primary_19rto_127'} _filled_19rto_80`}
        >
          {confirmButton || 'OK'}
        </button>
      </div>
    </ModalWrapper>
  );
};

export default CustomDialog;